import styled from 'styled-components';

const Button = styled.button`
  margin: 8px 0;
  border: 1px solid ${(props) => (props.borderColor) ? props.borderColor : '#44b4a6'};
  line-height: 100%;
  border-radius: ${(props) => (props.borderRadius) ? props.borderRadius : '4px'};
  font-size:${(props) => (props.fontSize) ? props.fontSize : '0.87em'};
  background-color: ${(props) => (props.backgroundColor) ? props.backgroundColor : '#44b4a6'};
  color: ${(props) => (props.color) ? props.color : '#fff'};
  padding: ${(props) => (props.padding) ? props.padding : '0.5em 1.25em'};
  min-width: 100px;
  cursor: pointer;
  &:hover {
    background-color:  ${(props) => (props.hoverBackgroundColor) ? props.hoverBackgroundColor : '#3e9e92'};
  }
  &:disabled {
      background-color: #AAC9BF;
      border-color: #AAC9BF;
    cursor: not-allowed;
    &:hover {
      background-color:  ${(props) => (props.backgroundColor) ? props.backgroundColor : '#AAC9BF'};
    }
  }
  @media screen and (max-width: 576px) {
      width: 100%;
      margin-left: 0;
      margin-right: 0;
  }
  &:focus {
    outline: none;
  }
`;

export default Button;



// WEBPACK FOOTER //
// ./app/containers/FastCover/components/Button/Button.js